module.exports = __webpack_public_path__ + "static/img/67.c7ffac3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/67.png
// module id = +wbu
// module chunks = 0